import { render, staticRenderFns } from "./PriorityStatusModal.vue?vue&type=template&id=1e540778"
import script from "./PriorityStatusModal.vue?vue&type=script&lang=js"
export * from "./PriorityStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports